import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export const styles = ({ spacing, palette }: Theme) =>
  createStyles({
    portNumber: {
      margin: spacing(0, 1),
    },
  });
